import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import ContactForm from "@/pages/contact/components/ContactForm";

export default function ContactPage() {
  return (
    <div className="w-full bg-background-50">
      <PageHero en="CONTACT" ja="お問い合わせ" crumbs={[{ label: "お問い合わせ" }]} />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
              <div>
                <span className="font-label text-xs tracking-[0.4em] text-secondary-500">
                  GET IN TOUCH
                </span>
                <h2 className="mt-6 font-display text-3xl font-light leading-[1.7] tracking-[0.04em] text-foreground-950 md:text-4xl">
                  お気軽に
                  <br />
                  お問い合わせください
                </h2>
                <p className="mt-8 font-body text-[15px] leading-[2.1] text-foreground-700">
                  事業のご相談、協業のご提案、採用に関するご質問など、
                  下記フォームよりお送りください。内容を確認のうえ、担当者より折り返しご連絡いたします。
                </p>

                <div className="mt-10 border-t border-background-300/70 pt-8">
                  <dl className="flex flex-col gap-5">
                    <div>
                      <dt className="font-label text-xs tracking-[0.24em] text-secondary-500">
                        法人名
                      </dt>
                      <dd className="mt-1 font-body text-sm text-foreground-950">
                        REVRA Group
                      </dd>
                    </div>
                    <div>
                      <dt className="font-label text-xs tracking-[0.24em] text-secondary-500">
                        代表者
                      </dt>
                      <dd className="mt-1 font-body text-sm text-foreground-950">
                        代表取締役 河出 享一郎
                      </dd>
                    </div>
                    <div>
                      <dt className="font-label text-xs tracking-[0.24em] text-secondary-500">
                        所在地
                      </dt>
                      <dd className="mt-1 font-body text-sm text-foreground-950">
                        未定（決定次第ご案内いたします）
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>

              <div className="border-t border-background-300/70 pt-10 lg:border-l lg:border-t-0 lg:pl-16 lg:pt-0">
                <ContactForm />
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}